<template>
  <div class="flex-fill" style="padding-left:1rem">
    <div >
      <div v-html="question.text"></div>

      <div class="flex-fill p-2">
        <media-preview v-if="question.media" v-model="question.media" style="margin:0 auto"/>
      </div>

      <div>
        <label>Choices</label>
        <div v-if="question.type == 'checkbox'">
          <b-form-checkbox-group id="checkbox-group-1" v-model="model.choice_ids" name="answers-1" stacked>
            <b-form-checkbox v-for="c in choices" :key="c.id" :value="c.id">
              {{ c.label }}
              <media-preview v-if="c.media" v-model="c.media" />
            </b-form-checkbox>
          </b-form-checkbox-group>
        </div>

        <ul v-if="question.type == 'radio'">
          <li v-for="c in choices" :key="c.id">
            <div class="p-1">
              <input v-model="selectedOption" :value="c.id" :name="componentId" type="radio"/>
              <label>{{ c.label }}</label>
              <media-preview v-if="c.media" v-model="c.media" style="margin-left:1.5rem"/>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import mediaPreview from '@/components/common/media/media-preview'

export default {
  components:{
    mediaPreview
  },
  props:{
    value: {type:null, default: ''},
    question: {type:Object, required: true}
  },
  data(){
    return {
    }
  },
  computed:{
    componentId(){
      return this._uid
    },
    choices(){
      return _.sortBy(this.question.choices, ['order'])
    },
    model:{
      get(){ return this.value},
      set(model) { this.$emit('input', model)}
    },
    selectedOption:{
      get(){
        if(this.model.choice_ids){
          return this.model.choice_ids[0]
        }else{
          return null
        }
      },
      set(option){
        if(option){
          this.model.choice_ids = [option]
        }else{
          this.model.choice_ids = []
        }
      }
    }
  },
  watch:{
    model(val){
      this.$emit('input', val)
    },
    value(val){
      this.model = val
    }
  },
  methods:{
    mediaUrl(choice){
      return choice.media.thumbnail ? choice.media.thumbnail.url : choice.media.url
    }
  }
}
</script>

<style lang="scss" scoped>
.question-label{
  margin-left: 1rem;
  min-width:1.25rem;
  white-space: nowrap !important;
}

.question-content{
  padding: 0 .5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/knowledge-checks/question.vue